/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  hasMany,
  belongsTo,
  attr,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import { mapBy, alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Person from '@linc-technologies/linced-common/models/person';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: finance.Account.
export default class Account extends Model {
  declare [Type]: 'finance/account';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('string')
  declare campusId: string | undefined; // TODO: implement when we have Campuses

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @belongsTo('person', { async: true, inverse: null })
  declare personId: AsyncBelongsTo<Person>;

  @alias('personId')
  declare person: AsyncBelongsTo<Person>;

  @alias('person.id')
  declare person_id: string | null | undefined;

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('number', { defaultValue: 0 })
  declare splitPercentage: number;

  @attr('number', { defaultValue: 0 })
  declare balance: number;

  @attr('boolean', { defaultValue: false })
  declare isArchived: boolean;

  @hasMany('person', { async: true, inverse: null })
  declare caregiverIds: AsyncHasMany<Person>;

  @alias('caregiverIds')
  declare caregivers: AsyncHasMany<Person>;

  // .content is the loaded ManyArray: the array macros ignore a
  // PromiseManyArray, which is not an array.
  @mapBy('caregivers.content', 'id')
  declare caregiver_ids: unknown[];

  //// Account Settings
  // Salutation to use in addresses, i.e. on Statements
  @attr('string', { defaultValue: '' })
  declare salutation: string;

  // ID of the person whose address should appear on statements, if any
  @attr('string', { defaultValue: '' })
  declare addressPersonId: string;

  // Custom address for statements, if not a Person's
  @attr('string', { defaultValue: '' })
  declare addressLine1: string;

  @attr('string', { defaultValue: '' })
  declare addressLine2: string;

  @attr('string', { defaultValue: '' })
  declare addressLine3: string;

  @attr('string', { defaultValue: '' })
  declare addressLine4: string;

  @attr('string', { defaultValue: '' })
  declare addressPostCode: string;

  // School's notes regarding this account
  @attr('string', { defaultValue: '' })
  declare notes: string;
}
